<h1>Edit Location - {{ locationModel.locationName }}</h1>

<form [formGroup]="editLocationForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="editLocationForm.touched && editLocationForm.invalid">
        <ul>
            <li *ngIf="editLocationForm.touched && editLocationForm.controls['locationName'].invalid">Location Name can't be empty.</li>
            <li *ngIf="editLocationForm.touched && editLocationForm.controls['branchId'].invalid">Branch can't be empty.</li>
            <li *ngIf="editLocationForm.touched && editLocationForm.controls['cost'].invalid">Cost can't be empty.</li>
            <li *ngIf="editLocationForm.touched && editLocationForm.errors?.exists">Location already exists.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="locationName">Location Name</label>
        <input
            id="locationName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="locationName"
            [ngClass]="{ 'input-validation-error': editLocationForm.touched && editLocationForm.controls['locationName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="branchId">Branch</label>
        <ng-select
            [items]="branches"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': editLocationForm.touched && editLocationForm.controls['branchId'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="cost">Cost</label>
        <input
            id="cost"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="cost"
            [ngClass]="{ 'input-validation-error': editLocationForm.touched && editLocationForm.controls['cost'].invalid }"
        />
    </div>
    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="isPublished" formControlName="isPublished" class="custom-control-input" />
            <label for="isPublished" class="custom-control-label cursor-pointer">is Published</label>
        </div>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">save</button>
        <button class="btn btn-danger btn-sm ml-2" type="button" (click)="confirmDelete(locationModel)">delete</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
